<ng-container *transloco="let t">

  <form [formGroup]="inputForm">
    <app-admin-card-with-title [cardTitle]="t('administrator.categories.addNewCategory')" [removeTopMargin]="true"
                               [showToggleButton]="true">
      <div class="row pt-3">
        <div class="col-12 col-xl-6 reduce-column-right-spacing mb-3 mb-xl-0">
          <app-input formControlName="name" label="administrator.categories.name" formId="name"/>
        </div>
        <div class="col-12 col-xl-6 reduce-column-left-spacing">
          @if (categoryTypes) {
            <app-select ngDefaultControl formControlName="categoryType" [items]="categoryTypes!" [valueKey]="'id'"
                        [labelKey]="'id'" labelKeyPrefix="administrator.categories.type."
                        label="administrator.categories.type"/>
          }
        </div>
      </div>

      <div ngbDropdown class="d-flex justify-content-end pt-3">
        <app-rounded-button [label]="t('administrator.categories.items.add')"
                            [isDisabled]="this.itemsMaleFormArray.controls.length > 0 &&
                            this.itemsFemaleFormArray.controls.length > 0" ngbDropdownToggle><i
          class="bi bi-plus-circle pe-2"></i></app-rounded-button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu">
          <button ngbDropdownItem (click)="addMaleCategoryItems()"
                  [disabled]=" this.itemsMaleFormArray.controls.length > 0">{{
              t("administrator.categories.items.gender.1")
            }}
          </button>
          <button ngbDropdownItem (click)="addFemaleCategoryItems()"
                  [disabled]=" this.itemsFemaleFormArray.controls.length > 0">{{
              t("administrator.categories.items.gender.2")
            }}
          </button>
        </div>
      </div>
      @if (itemsMaleFormArray.controls.length > 0) {
        <app-category-item-form [inputForm]="inputForm" [currentCategory]="category" [itemsKey]="'itemsMale'"
                                (deleteCategoryItems)="deleteCategoryItem(1)"
                                [gender]="1" [errors]="maleCategoryItemsErrors"
                                [label]="t('administrator.categories.items.man')"/>
      }
      @if (itemsFemaleFormArray.controls.length > 0) {
        <app-category-item-form [inputForm]="inputForm" [currentCategory]="category" [gender]="2"
                                [itemsKey]="'itemsFemale'"
                                (deleteCategoryItems)="deleteCategoryItem(2)"
                                [errors]="femaleCategoryItemsErrors"
                                [label]="t('administrator.categories.items.women')"/>
      }

    </app-admin-card-with-title>

    <app-action-buttons-row (onSave)="onSave()" (onCancel)="onCancel()" [cancelVisible]="true"/>
  </form>
</ng-container>
